module.exports = __webpack_public_path__ + "static/media/telegram.17209400.svg";